import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import AppContext from './Context/AppContext';
import useGlobalState from './hooks/useGlobalState';
import AppRoute from './Routes/AppRoute';
import routes from './Routes/routes';
import Login from './Components/Common/Login/Login';
import LoadingSection from './Components/LoadingSection/LoadingSection';
import 'moment/locale/es';
import "./App.css";

const App = () => {
    const globalState = useGlobalState();

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--vh',
            `${window.innerHeight / 100}px`
        );
    }, []);

    return (
        <div className="App">
            <AppContext.Provider value={globalState}>
                <Switch>
                    <Route exact path="/" component={Login} />
                    {routes.map((route, index) => (
                        <AppRoute
                            key={route.path}
                            path={route.path}
                            component={route.component}
                            isPrivate={route.isPrivate}
                            exact={route.isExact}
                            index={index}
                        />
                    ))}
                </Switch>
            <LoadingSection />
            </AppContext.Provider>

        </div>
    );
};

export default App;
